const actions = {
  updateAccessToken({ commit }, token) {
    commit('UPDATE_ACCESS_TOKEN', token);
  },
};

export default actions;
